import { Client_Event_Name, Server_Event_Name, } from '@quiz-buzz/common'
import {useForm} from 'react-hook-form'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { style } from 'typestyle'
import { Button, button_input_attach_style, input_button_attached_style } from '../Components/Button'
import { header_over_form_style } from '../App/style/Headers'
import { validation_error_style, validation_warn_style } from '../App/style/Forms'
import { host_machine_actor } from '../App/main'

type FormValues = {
	host_email: string
}

export function Host_Registration() {

	const {
		register,
		handleSubmit,
		formState: {errors}
	} = useForm<FormValues>({
		defaultValues: {
		}
	})

	const onSubmit = handleSubmit(data => {
		return fetch('/api/v1/resume-game', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			// use the "body" param to optionally pass additional order information
			// like product ids and quantities
			body: JSON.stringify({
				detail: { 
					host_email: data.host_email
				},
			}),
		})
		.then(response => {
			if (response.status === 200) {
				host_machine_actor.send({ type: Server_Event_Name.game_setup_unverified, detail: { host_email: data.host_email } })	
			}
			else {
				throw new Error('Failed to request host verification email')
			}
		})
	})


	const header = (
		<>
			<div className={page_header_style}>Host login</div>
			<div className={sub_header_style}>let&apos;s get you started</div>
		</>
	)
	const content = (
		<>
			<div className={header_over_form_style}>
				<div className="h2"><label htmlFor="host_email">Please enter your email</label></div>
			</div>
			<form id="host_reg_form" className={host_reg_form_style} onSubmit={onSubmit}>
				<input
					id="host_email"
					type="email"
					data-help-tip="intro"
					className={input_button_attached_style + ' ' + (errors.host_email ? validation_warn_style : '')}
					{...register('host_email', {
						required: {
							value: true,
							message: 'email is required!',
						},
						maxLength: {value: 100, message: 'too long'},
						minLength: {value: 3, message: 'too short'},
					})}
					placeholder="email address"
				/>
				<button className={button_input_attach_style} type="submit">&gt;</button>
				{errors.host_email ? <div className={validation_error_style}>
					{errors.host_email?.message}
				</div> : ''}
			</form>
		</>
	)

	const controls = (
		<div className="two_buttons">
			<Button text="Cancel" button_style="Danger" onClick={() => host_machine_actor.send({ type: Client_Event_Name.navigate_back })} />
			<Button text="Start setup" button_style="Primary" type="submit" form="host_reg_form" />
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}

const host_reg_form_style = style({
	margin: '0 auto',
	flex: 1,
})


